import { useEffect, useRef } from "react";
import {
  Stage,
  StageEvents,
  SubscribeType,
} from "amazon-ivs-web-broadcast";

export default function IVSViewer({token, participantId, cameraName}) {
  const videoRef = useRef(null);

  useEffect(() => {
    let stage;
    const mediaStream = new MediaStream();

    async function init() {
      try {
        console.log("Participant ID:", participantId);

        const strategy = {
          // Viewer kuch publish nahi karega
          stageStreamsToPublish() {
            return [];
          },

          shouldPublishParticipant() {
            return false;
          },

          // Sab remote participants subscribe karo
          shouldSubscribeToParticipant(participant) {
            console.log("Subscribing to:", participant);

            return SubscribeType.AUDIO_VIDEO;
          },
        };

        stage = new Stage(token, strategy);

        /**
         * Participant joined
         */
        stage.on(
          StageEvents.STAGE_PARTICIPANT_JOINED,
          (participant) => {
            console.log(
              "Participant joined:",
              participant.id,
              participant.info
            );
          }
        );

        /**
         * Streams added
         */
        stage.on(
          StageEvents.STAGE_PARTICIPANT_STREAMS_ADDED,
          (participant, streams) => {
            console.log(
              "Streams added from:",
              participant.id
            );

            streams.forEach((stream) => {
              mediaStream.addTrack(
                stream.mediaStreamTrack
              );
            });

            if (videoRef.current) {
              videoRef.current.srcObject = mediaStream;
            }
          }
        );

        /**
         * Streams removed
         */
        stage.on(
          StageEvents.STAGE_PARTICIPANT_STREAMS_REMOVED,
          (participant, streams) => {
            console.log(
              "Streams removed from:",
              participant.id
            );

            streams.forEach((stream) => {
              mediaStream.removeTrack(
                stream.mediaStreamTrack
              );
            });
          }
        );

        /**
         * Errors
         */
        stage.on(StageEvents.ERROR, (err) => {
          console.error("IVS Error:", err);
        });

        /**
         * Join stage
         */
        await stage.join();

        console.log(
          "Joined stage as:",
          participantId
        );
      } catch (err) {
        console.error("Init failed:", err);
      }
    }

    init();

    return () => {
      if (stage) {
        stage.leave();
      }
    };
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      controls
      muted
      width="640"
      height="360"
      className="live-video-player"
      style={{ backgroundColor: "black" }}
      aria-label={`Live streaming from ${cameraName}`}
    />
  );
}

